<template>
  <section class="pb-16">
    <!-- <div class="w-full h-3 bg-[#f2f2f2]"></div>
    <BlSectionHeaderMv text-title="Kartu Prakerja untuk Indonesia" />
    <BlTextAv class="ph-16 pb-16 leading-4" variation="caption-12">
      Kartu Prakerja adalah program pemerintah berupa pengembangan kompetensi kerja dan kewirausahaan untuk para pencari kerja, buruh yang
      terkena pemutusan hubungan kerja (PHK), dan buruh yang membutuhkan peningkatan kompetensi, termasuk pelaku usaha mikro dan kecil.
      Selama pandemi COVID-19, program kartu pekerja diprioritaskan untuk pekerja/buruh yang dirumahkan dan pelaku usaha mikro dan kecil
      yang terdampak penghidupannya.

      <br />
      <br />
      Program Kartu Prakerja disusun dan dirumuskan oleh Komite Cipta kerja yang dibentuk lewat Peraturan Presiden Nomor 36 Tahun 2020
      tentang Pengembangan Kompetensi Kerja yang kini telah berubah menjadi Peraturan Presiden Nomor 76 Tahun 2020. Komite Cipta Kerja juga
      mengendalikan dan mengevaluasi pelaksanaan program Kartu Prakerja.

      <br />
      <br />

      Semua warga Indonesia yang berusia 18 tahun ke atas dan non-pelajar bisa mendaftar kecuali pejabat negara, pimpinan dan anggota dewan
      perwakilan rakyat daerah (DPRD), aparatur sipil negara (ASN), prajurit tentara nasional indonesia (TNI), anggota kepolisian negara
      republik Indonesia, kepala desa dan perangkat desa, direksi, komisaris dan dewan pengawas badan usaha milik negara (BUMN) atau badan
      usaha milik daerah (BUMD).
    </BlTextAv> -->

    <div class="w-full h-3 bg-[#f2f2f2]"></div>

    <div class="p-16 flex items-center">
      <BlTextAv class="mr-12">Didukung oleh</BlTextAv>
      <img :src="$publicUrl('images/kartu-prakerja/logo-prakerja.png')" width="64" alt="Logo Prakerja" loading="lazy" />
    </div>
  </section>
</template>

<script>
// import {BlSectionHeaderMv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaFooter',
  components: {
    // BlSectionHeaderMv,
  },
};
</script>
